import {Alert, Button, Card, CardBody, CardFooter, CardHeader, Typography,} from "@material-tailwind/react";
import {useEffect, useState} from "react";
import Dict from "../../helper/dict";
import {updatePassword} from "../../services/user/change_password";
import {BsCheckCircle} from "react-icons/bs";
import {Toaster} from "../../helper/Toaster";
import PasswordField from "../system/passwordField";


export function ChangePassword() {

  const [password, setPassword] = useState("")
  const [newPassword, setNewPassword] = useState("")
  const [confirmPassword, setConfirmPassword] = useState("")
  const [success, setSuccess] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const [loading, setLoading] = useState(false);

  useEffect(() => {

  }, [success]);

  const save = async () => {
    if (loading) return; // Prevent multiple simultaneous requests
    
    const data = {
      password: password,
      new_password: newPassword,
      confirm_password: confirmPassword,
    };
    
    try {
      setLoading(true);
      
      if (newPassword === confirmPassword) {
        let result = await updatePassword(data);

        if (result.status === 200) {
          setSuccess(true);
        } else {
          Toaster.failure(null, <Typography variant="small">
            {result.data?.message || 'خطا در تغییر رمز عبور'}
          </Typography>);
        }
      } else {
        Toaster.failure(null, <Typography variant="small">
          رمز عبور جدید با تکرار آن برابر نیست
        </Typography>);
      }
    } catch (err) {
      Toaster.failure(null, <Typography variant="small">
        {err.message || 'خطا در تغییر رمز عبور'}
      </Typography>);
      console.error('Change password error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mr-8">
      <Card className="pt-8 md:w-1/2">
        <CardHeader floated={true} shadow={false} className="rounded-none">
          <div className="mb-8 flex text-center items-center justify-between gap-8">
            <Typography variant="h5" color="blue-gray">تغییر رمز عبور</Typography>
          </div>
          {success &&
            <Alert className="flex flex-row my-4">
              <Typography className="flex font-semibold">
                <BsCheckCircle className="flex ml-2 text-xl"/>
                رمز عبور با موفقیت تغییر کرد
              </Typography>
            </Alert>
          }
        </CardHeader>
        <CardBody className="overflow-x-auto w-full">
          <div className="grid grid-cols-1">

            <div className="flex w-full mb-4 md:max-w-[24rem]">
              <PasswordField
                label={Dict('old_password')}
                onChange={setPassword}
              />
            </div>

            <div className="flex w-full mb-4 md:max-w-[24rem]">
              <PasswordField
                label={Dict('new_password')}
                onChange={setNewPassword}
              />
            </div>

            <div className="flex w-full mb-4 md:max-w-[24rem]">
              <PasswordField
                label={Dict('confirm_password')}
                onChange={setConfirmPassword}
              />
            </div>

          </div>
        </CardBody>

        <CardFooter className="flex items-center justify-center border-t border-blue-gray-50 p-4">
          <Button variant="gradient" color="gray" onClick={save} className="ml-1" disabled={loading}>
            {loading ? 'در حال ذخیره...' : 'ذخیره'}
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
}